module.exports = __webpack_public_path__ + "static/media/robin.75d755fa.jpeg";